module.exports = __webpack_public_path__ + "img/placeholder-image.3693c525.png";